import angular from 'angular';
import template from './autocomplete.html';
export var AutocompleteComponent = {
    template: template,
    bindings: {
        placeholder: '@',
        searchText: '=',
        items: '@',
        inputId: '@',
        onSubmit: '&',
        target: '@' // querySelector of the element that the dropdown should be sized and positioned off of
    },
    transclude: true,
    controller: /** @class */ (function () {
        function AutocompleteComponent($scope, $element, $timeout, $q) {
            'ngInject';
            this.showDropdown = false;
            this.targetEl = null;
            this.dropdownContentEl = null;
            this.loading = false;
            this.itemName = '';
            this.itemExpr = '';
            this.results = null;
            this.emptyState = false;
            this.error = false;
            this.$scope = $scope;
            this.$element = $element;
            this.$timeout = $timeout;
            this.$q = $q;
        }
        AutocompleteComponent.prototype.$onInit = function () {
            var itemParts = this.items.split(/ in /i);
            this.itemName = itemParts[0];
            this.itemExpr = itemParts[1];
        };
        AutocompleteComponent.prototype.$onDestroy = function () {
            this.$element.off('keyup', this.escKeyHandler);
            this.$element.off('click', this.elemClickHandler);
            angular.element(document).off('click', this.domClickHandler);
        };
        AutocompleteComponent.prototype.$postLink = function () {
            this.attachDropdown();
            this.positionAndShowDropdown();
            this.setEscKeyHandler();
            this.setClickHandlers();
        };
        AutocompleteComponent.prototype.attachDropdown = function () {
            this.targetEl = this.target && this.target.length
                ? angular.element(document.querySelector(this.target))
                : angular.element(this.$element[0].querySelector('input[type="search"]'));
            var dropdownEl = angular.element(this.$element[0].querySelector('dropdown-item-template'));
            this.dropdownContentEl = angular.element(dropdownEl[0].querySelector('.dropdown-item-template'));
            angular.element(document.body).append(dropdownEl);
        };
        AutocompleteComponent.prototype.positionAndShowDropdown = function () {
            if (this.targetEl) {
                var offsets = this.targetEl[0].getBoundingClientRect();
                var doc = this.targetEl[0] && this.targetEl[0].ownerDocument;
                var documentElem = doc.documentElement;
                this.dropdownContentEl.css('width', offsets.width + 'px');
                this.dropdownContentEl.css('top', offsets.top +
                    (window.pageYOffset || documentElem.scrollTop) - (documentElem.clientTop || 0) + offsets.height + 'px');
                this.dropdownContentEl.css('left', offsets.left +
                    (window.pageXOffset || documentElem.scrollLeft) - (documentElem.clientLeft || 0) + 'px');
            }
            this.showDropdown = true;
        };
        AutocompleteComponent.prototype.setEscKeyHandler = function () {
            var _this = this;
            this.escKeyHandler = this.$element.bind('keyup', function (event) {
                if (event.which === 27) {
                    _this.$scope.$apply(function () {
                        _this.cancelSearch();
                        angular.element(_this.$element[0].querySelector('input[type="search"]')).blur();
                        _this.searchText = '';
                        _this.showDropdown = false;
                    });
                }
            });
        };
        AutocompleteComponent.prototype.setClickHandlers = function () {
            var _this = this;
            this.domClickHandler = angular.element(document).bind('click', function (event) {
                _this.showDropdown = false;
            });
            this.elemClickHandler = this.$element.bind('click', function (event) {
                event.stopPropagation();
            });
        };
        AutocompleteComponent.prototype.cancelSearch = function () {
            this.$timeout.cancel(this.fetchTimeout);
            this.loading = false;
        };
        AutocompleteComponent.prototype.clearSearchClicked = function ($event) {
            this.cancelSearch();
            this.searchText = '';
            angular.element(this.$element[0].querySelector('input[type="search"]')).focus();
            this.showDropdown = true;
        };
        AutocompleteComponent.prototype.onSearchTextChange = function () {
            if (this.searchText && this.searchText.length) {
                this.showDropdown = true;
            }
        };
        AutocompleteComponent.prototype.fetchResults = function (searchText) {
            var _this = this;
            this.error = false;
            this.emptyState = false;
            if (this.showDropdown) {
                this.loading = true;
                // use timeout to debounce typeahead api requests for 500 ms and allow the searchText
                // to be updated across scopes before executing
                this.$timeout.cancel(this.fetchTimeout);
                this.fetchTimeout = this.$timeout(function () {
                    var items = _this.$scope.$parent.$eval(_this.itemExpr);
                    var isList = angular.isArray(items);
                    var isPromise = !!items.then; // Every promise should contain a `then` property
                    if (isList) {
                        _this.results = items;
                        _this.loading = false;
                    }
                    else if (isPromise) {
                        _this.handleAsyncResults(items);
                    }
                }, 500);
            }
        };
        AutocompleteComponent.prototype.handleAsyncResults = function (items) {
            var _this = this;
            if (!items)
                return;
            items = this.$q.when(items);
            items
                .then(function (data) {
                var hasResults = data && data.length;
                for (var prop in data) {
                    if (data[prop].length) {
                        hasResults = true;
                    }
                }
                _this.emptyState = !hasResults;
                _this.results = data;
            })
                .catch(function () {
                _this.error = true;
            })
                .finally(function () {
                _this.loading = false;
            });
        };
        return AutocompleteComponent;
    }())
};
//# sourceMappingURL=autocomplete.component.js.map